import { Injectable, inject } from '@angular/core';

import { OddsAcceptanceMode } from '@bpos';
import { OddsConfig } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { BettingSettingsService, UserService } from '@frontend/sports/user/feature';
import { OnAppInit } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { switchMap } from 'rxjs';

import { IBetslipDigitalRootState } from '../../betslip/digital/state';
import { SettingsActions } from '../../betslip/modules/settings/actions';
import { OddsAcceptance } from '../betslip-base/models/odds-acceptance.enum';
import { ModalPopUpComponent } from './modal-pop-up-info.component';

@Injectable({
    providedIn: 'root',
})
export class OddAcceptanceModeFilterService implements OnAppInit {
    private modalDialogService = inject(ModalDialogService);
    private userService = inject(UserService);
    private oddsConfig = inject(OddsConfig);
    private store = inject<Store<IBetslipDigitalRootState>>(Store);
    private bettingSettingsService = inject(BettingSettingsService);
    private productUtils = inject(SportsProductUtils);

    private modalDialogRef: Nullable<ModalRef>;
    selectedOddAcceptance: OddsAcceptanceMode = OddsAcceptanceMode.Higher;

    onAppInit(): void {
        this.userService.onUserLogInWithSettings$
            .pipe(
                this.productUtils.filterSportsEmitLast(),
                switchMap(() => this.bettingSettingsService.bettingSettings$),
            )
            .subscribe((bettingSettings) => {
                if (
                    bettingSettings.oddsAcceptanceMode === OddsAcceptance.No &&
                    this.oddsConfig.showOddsAcceptanceSettings &&
                    this.oddsConfig.hideDontAcceptOptionSetting
                ) {
                    this.store.dispatch(SettingsActions.requestSetOddAcceptance({ acceptance: this.selectedOddAcceptance }));

                    if (!this.modalDialogRef) {
                        this.modalDialogRef = this.modalDialogService.openDialog(ModalPopUpComponent, {
                            settings: {
                                isModalDialog: false,
                                hideCloseButton: true,
                                cssClass: 'betting-settings-update__modal',
                                backdropClass: 'betting-settings-update__modal-backdrop',
                            },
                        });
                    }

                    if (this.modalDialogRef) {
                        this.modalDialogRef.result.then(() => this.closeModal());
                    }
                }
            });

        this.userService.onUserLogout$.pipe(this.productUtils.filterSportsEmitLast()).subscribe(() => {
            this.closeModal();
        });
    }

    private closeModal(): void {
        if (this.modalDialogRef) {
            this.modalDialogRef.close();
            this.modalDialogRef = null;
        }
    }
}
